import React from 'react';
import USFlag from '../../../../../icons/flags/us.svg';
import AUFlag from '../../../../../icons/flags/au.svg';
import CAFlag from '../../../../../icons/flags/ca.svg';
import DEFlag from '../../../../../icons/flags/de.svg';
import FRFlag from '../../../../../icons/flags/fr.svg';
import GBFlag from '../../../../../icons/flags/gb.svg';
import EUFlag from '../../../../../icons/flags/eu.svg';

const StoreFlag = ({ storeCode, style, id = null }) => {
   const svgProps = {
      style,
      id,
      'data-country': storeCode,
   };

   switch (storeCode.toUpperCase()) {
      case 'AU':
         return <AUFlag {...svgProps} />;
      case 'CA':
         return <CAFlag {...svgProps} />;
      case 'DE':
         return <DEFlag {...svgProps} />;
      case 'FR':
         return <FRFlag {...svgProps} />;
      case 'GB':
         return <GBFlag {...svgProps} />;
      case 'EU':
         return <EUFlag {...svgProps} />;
      case 'US':
      default:
         return <USFlag {...svgProps} />;
   }
};

export default StoreFlag;
